import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoHelpCircle as HelpIcon, IoAdd as Plus, IoRemove as Minus } from 'react-icons/io5';

export default function ScaleTool({ zoom, handleZoom, processImage, isProcessing, showToolTip }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-500 overflow-hidden border border-gray-100">
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">{t('scale.title')}</h3>
          <button
            onMouseEnter={(e) => showToolTip(t('scale.tooltip'), e)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <HelpIcon size={16} />
          </button>
        </div>

        <div className="flex items-center justify-center gap-8 py-6">
          <button
            onClick={() => handleZoom(zoom - 10)}
            className="bg-gray-50 p-3 rounded-full hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transform hover:scale-110 hover:shadow-sm"
            aria-label={t('scale.decrease.aria')}
          >
            <Minus size={20} />
          </button>

          <div className="text-center p-5 bg-gray-50 rounded-xl min-w-[140px] shadow-sm">
            <span className="text-3xl font-bold text-blue-600">{zoom}%</span>
            <p className="text-sm text-gray-500 mt-1">{t('scale.ratioLabel')}</p>
          </div>

          <button
            onClick={() => handleZoom(zoom + 10)}
            className="bg-gray-50 p-3 rounded-full hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transform hover:scale-110 hover:shadow-sm"
            aria-label={t('scale.increase.aria')}
          >
            <Plus size={20} />
          </button>
        </div>

        <div className="px-2">
          <input
            type="range"
            min="10"
            max="200"
            value={zoom}
            onChange={(e) => handleZoom(Number(e.target.value))}
            className="w-full h-2 bg-gray-100 rounded-lg appearance-none cursor-pointer accent-blue-600"
            aria-label={t('scale.slider.aria')}
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>10%</span>
            <span>100%</span>
            <span>200%</span>
          </div>
        </div>

        <div className="pt-2">
          <button
            onClick={() => processImage('scale')}
            disabled={isProcessing}
            className={`w-full py-3 rounded-lg transition-all duration-300 font-medium ${
              isProcessing
                ? 'bg-blue-400 text白 cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm hover:shadow transform hover:-translate-y-0.5'
            }`}
          >
            {isProcessing ? (
              <div className="flex items-center justify中心 gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                {t('common.processing')}
              </div>
            ) : t('scale.apply')
            }
          </button>
        </div>
      </div>
    </div>
  );
}